/**
 * Valida y corrige JSON strings mal formados
 * @param {string} jsonString - El JSON string a validar y corregir
 * @returns {object|null} - El objeto JSON parseado o null si no se puede corregir
 */
export function validateAndFixJSON(jsonString) {
  if (!jsonString || typeof jsonString !== 'string') {
    return null;
  }

  try {
    // Primero intentar parsear directamente
    return JSON.parse(jsonString);
  } catch {
    console.warn('JSON mal formado detectado, intentando corregir...');

    // Intentar corregir problemas comunes
    let fixedString = jsonString;

    // Corregir claves sin comillas: {color: ""} -> {"color": ""}
    fixedString = fixedString.replace(/(\w+):/g, '"$1":');

    // Corregir valores sin comillas: {"color": red} -> {"color": "red"}
    fixedString = fixedString.replace(/:\s*([^",{}[\]\s][^,{}[\]]*[^",{}[\]\s])\s*([,}\]])/g, ':"$1"$2');

    // Corregir comas finales
    fixedString = fixedString.replace(/,(\s*[}\]])/g, '$1');

    try {
      return JSON.parse(fixedString);
    } catch (secondError) {
      console.error('No se pudo corregir el JSON:', secondError);
      return null;
    }
  }
}
